/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import save from './save';
export var name = 'core/navigation-menu';
export var settings = {
  title: __('Navigation Menu (Experimental)'),
  icon: 'menu',
  description: __('Add a navigation menu to your site.'),
  keywords: [__('menu'), __('navigation'), __('links')],
  supports: {
    align: ['wide', 'full'],
    anchor: true,
    html: false,
    inserter: true
  },
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map